import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { useMusicPlayer } from "@/context/MusicPlayerContext";
import { useI18n } from "@/context/I18n";
import TrackRow from "@/components/music/TrackRow";
import { Loader2, Play, ListMusic } from "lucide-react";

export default function CollectionDetail() {
  const { name } = useParams();
  const decoded = decodeURIComponent(name);
  const [data, setData] = useState(null);
  const { playQueue } = useMusicPlayer();
  const { t } = useI18n();

  useEffect(() => {
    api
      .get(`/music/collections/${encodeURIComponent(decoded)}/tracks`)
      .then((r) => setData(r.data))
      .catch(() => setData(false));
  }, [decoded]);

  if (data === null) {
    return (
      <div className="p-10 flex justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-zinc-500" />
      </div>
    );
  }
  if (data === false) return <div className="p-10 text-zinc-400">...</div>;

  const cover = data.tracks[0]?.thumbnail;

  return (
    <div data-testid="collection-detail">
      <div className="p-4 md:p-8 pb-6 bg-gradient-to-b from-zinc-600/30 to-transparent flex items-end gap-6">
        {cover ? (
          <img src={cover} alt="" className="w-32 h-32 md:w-40 md:h-40 rounded-xl object-cover shadow-2xl shrink-0" />
        ) : (
          <div className="w-32 h-32 md:w-40 md:h-40 rounded-xl bg-white/10 flex items-center justify-center shrink-0">
            <ListMusic className="w-14 h-14 text-zinc-500" />
          </div>
        )}
        <div className="min-w-0">
          <p className="text-xs uppercase tracking-wider font-bold">{t("collections")}</p>
          <h1 className="font-display text-3xl md:text-5xl font-black tracking-tighter mt-2 break-words">
            {decoded}
          </h1>
          <p className="text-zinc-300 mt-3 text-sm">
            {data.tracks.length} {t("tracks")}
          </p>
        </div>
      </div>

      <div className="px-4 md:px-8 py-4">
        <button
          data-testid="collection-play-all"
          onClick={() => data.tracks.length && playQueue(data.tracks, 0)}
          className="w-14 h-14 rounded-full bg-[#FF2A4D] hover:bg-[#E61C3D] hover:scale-105 flex items-center justify-center transition-all"
        >
          <Play className="w-6 h-6 text-white ml-1" fill="white" />
        </button>
      </div>

      <div className="px-4 md:px-8 pb-8">
        {data.tracks.map((track, i) => (
          <TrackRow key={track.id} track={track} index={i} tracks={data.tracks} />
        ))}
      </div>
    </div>
  );
}
